import React from 'react';
import { Modal} from 'react-bootstrap';
import {connect} from 'react-redux';
import {personFullName} from "../../../../services/Api";
import SelectAsync from 'react-select/lib/Async';
import _ from "lodash";
import PropTypes from "prop-types";

class AddCongressModal extends React.Component{

    static contextTypes = { api:PropTypes.object, notifier: PropTypes.object };

    constructor( props ){
        super(props);
        const person = props.person;
        this.state = {
            form: {
                member: personFullName(person)
            }
        };
        this.loadCongresses = _.debounce(this.loadCongresses, 250);
    }

    onFormChange = ({target})=> this.setState(  { form:{...this.state.form, [target.name]:target.value}} );

    loadCongresses = ( name )=>{
        return this.context.api.congresses.get( 0, 10, undefined, {name:name})
            .then( (congresses=[])=> congresses.map( (congress)=>({value:congress.id, label: congress.name }) ) ) };

    getFormValue = ( name )=>{
        return this.state.form[name]? this.state.form[name]:'';
    };

    saveAttendance = () =>{
        if(!this.state.form.congress) return this.context.notifier.error('Debes introducir el congreso a asignar');
        const attendance = {"person":this.props.person.id,"congress":this.state.form.congress.value};
        this.context.api.congressAttendances.create( attendance, undefined).then(this.finish);
    };

    finish = ()=>{
        if( this.props.didSave ) {this.props.didSave();}
        this.props.onHide();
    };

    render(){

        const { onHide } = this.props;

        return (
            <Modal show={true}
                onHide={ onHide }>
                <Modal.Header closeButton>
                    <Modal.Title>{'Añadir congreso a miembro'}</Modal.Title>
                </Modal.Header>
                <Modal.Body >
                    <p><b>Miembro:</b> {this.getFormValue('member')}</p>
                    <SelectAsync
                        cacheOptions
                        placeholder='Nombre del congreso'
                        noOptionsMessage={()=>"Sin coincidencias"}
                        loadOptions={this.loadCongresses}
                        onChange={(value)=>this.onFormChange({target:{name:"congress", value}})}
                        value={ this.getFormValue('congress') }
                    />
                </Modal.Body>
                <Modal.Footer>
                    <button onClick={ this.props.onHide } className='btn btn-primary pull-left'>Cancelar</button>
                    <button className='btn btn-danger' onClick={this.saveAttendance}>Añadir</button>
                </Modal.Footer>
            </Modal>
        );
    }
}

const mapStateToProps = ( { api:{congresses=[], congressesMeta={},simplePeople=[]}, loadingIds } )=>({simplePeople, congresses, congressesMeta, loadingIds});

export default connect(mapStateToProps)(AddCongressModal);


// WEBPACK FOOTER //
// ./src/App/scenes/AppFrame/components/AddCongressAttendanceModal/index.jsx